import { Button, Spinner } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import tinycolor from "tinycolor2";
import { getSessionId } from "../../client/sessionSetup";
import { sendKafkaEvent } from "../../client/wss";
import appstore from "../../store/appStore";
import axios from "axios";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { ProductContext } from "./ProductContext";
import { get } from "lodash";

export const ProductCart = ({ ele, botDetails }) => {
  const { cartList, getShopifyCart, getBigcommerceCart, addCreateCartUlai,cartId ,origin,href} =
    appstore();
    // console.log(cartId,"=============+> cartId")
    const { getData,setGetData } = useContext(ProductContext);

    const [isExist, setIsExist] = useState(false);
    const [selectedVarient, setSelectedvarient] = useState("");
  const [qtyCount, setQtyCount] = useState(0);

  const [outOfStock, setOutOfStock] = useState(false);
  const [showButtonLoader, setShowButtonLoader] = useState(false);
  const cartPath =
    botDetails.storeName === "Bigcommerce"
      ? "/cart.php"
      : botDetails.storeName === "Shopify"
      ? "/cart"
      : "";
  // let qtyCount = 0;
  const selectVarient = (data) => {
    // console.log("selectVarient", data);
    const selectedVariant = ele.varient.find(
      (ele) => ele.varientId === parseInt(data)
    );
    setOutOfStock(selectedVariant?.isOutOfStock);
    // console.log("selectedVariant", outOfStock);
    setSelectedvarient((preValue) => data);
  };

useEffect(()=>{
if(getData){
  if(botDetails.storeName === "Shopify"){
  const cart=getData
  let tempList = [];
  let productArray = [];
  cart?.items?.forEach((element) => {
    tempList.push(element?.product_id);
    productArray.push({
      productId: element?.product_id,
      quantity: element?.quantity,
      varient: [{ varientId: element?.variant_id }],
    });
  });
  let totalPrice = cart?.total_price?.toString();
  let subTotal = cart?.items_subtotal_price?.toString();
  addCreateCartUlai(
    cart?.token,
    ele?.userId,
    productArray,
    Number(
      `${totalPrice?.slice(
        0,
        totalPrice?.length - 2
      )}.${totalPrice?.slice(-2)}`
    ),
    Number(
      `${subTotal?.slice(0, subTotal?.length - 2)}.${subTotal?.slice(
        -2
      )}`
    )
    
  );
  setIsExist(
    tempList.includes(parseInt(ele?.productId)) ? true : false
  );
  setShowButtonLoader(false);
}
else{
  addCreateCartUlai(
    getData?.response?.id,
    getData?.ele?.userId,
    getData?.productArray,
    getData?.totalPrice,
    getData?.subTotal
  );
  setIsExist(getData?.cart.includes(parseInt(getData.ele?.productId)) ? true : false);
  setShowButtonLoader(false);
}
  // setGetData(null)
}
},[getData])

  const shopifyFlow = async () => {

      let item = [
        {
          id: selectedVarient,
          quantity: qtyCount + 1,
        },
      ];
      let formData = {
        items:item,
      };
      window.parent.postMessage({ type: "shopifyFlow", formData }, "*");
    //   console.log("shopifyFlow", formData);
    //   const response = await fetch(
    //     window?.Shopify?.routes?.root + "cart/add.js",
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify(formData),
    //     }
    //   )
    //     .then(async (response) => {
    //       // if (response?.status === 200) {
    //       //   const resp = await fetch(
    //       //     window?.Shopify?.routes?.root + "cart.js",
    //       //     {
    //       //       method: "GET",
    //       //       headers: {
    //       //         "Content-Type": "application/json",
    //       //       },
    //       //     }
    //       //   );
    //       //   let cart = await resp.json();
    //       //   let tempList = [];
    //       //   let productArray = [];
    //       //   cart?.items?.forEach((element) => {
    //       //     tempList.push(element?.product_id);
    //       //     productArray.push({
    //       //       productId: element?.product_id,
    //       //       quantity: element?.quantity,
    //       //       varient: [{ varientId: element?.variant_id }],
    //       //     });
    //       //   });
    //       //   let totalPrice = cart?.total_price?.toString();
    //       //   let subTotal = cart?.items_subtotal_price?.toString();
    //       //   addCreateCartUlai(
    //       //     cart?.token,
    //       //     ele?.userId,
    //       //     productArray,
    //       //     Number(
    //       //       `${totalPrice?.slice(
    //       //         0,
    //       //         totalPrice?.length - 2
    //       //       )}.${totalPrice?.slice(-2)}`
    //       //     ),
    //       //     Number(
    //       //       `${subTotal?.slice(0, subTotal?.length - 2)}.${subTotal?.slice(
    //       //         -2
    //       //       )}`
    //       //     )
    //       //   );
    //       //   setIsExist(
    //       //     tempList.includes(parseInt(ele.productId)) ? true : false
    //       //   );
    //       //   setShowButtonLoader(false);
    //       // }
    //     })
    //     .catch((error) => {
    //       return error;
    //     });
    // } catch (error) {
    //   // Handle general errors
    //   console.error("Error in shopifyFlow:", error);
    //   return { error: error.message };
    // }
  };


  //   const bigcommerceFlow = async () => {
  //     try {
  //       // console.log("Bigcommerce product date ----> ", selectedVarient);

  //       let formData = new FormData();
  //       // console.log("formData", formData);

  //       formData.append("action", "add");
  //       // console.log("action", formData);

  //       formData.append("product_id", ele.productId);
  //       // console.log("product_id", formData);
  // // if(ele.varient)
  //       formData.append("attribute[113]", selectedVarient);
  //       // console.log("attribute", formData);

  //       formData.append("qty", qtyCount + 1);
  //       // console.log("qty", formData);

  //       // for (const entry of formData.entries()) {
  //       //   console.log(entry[0], entry[1]);
  //       // }

  //       // console.log(formData.entries(), String(formData.values));

  //       const response = await fetch(
  //         `${origin}/remote/v1/cart/add`,
  //         {
  //           method: "POST",
  //           body: formData,
  //         }
  //       );

  //       if (response.status === 200) {
  //         console.log("Going to getBigcommerceCart");
  //         await getBigcommerceCart();
  //       }
  //     } catch (error) {
  //       console.log("Entered bigcommerceFlow catch block");

  //       // Handle general errors
  //       console.error("Error in bigcommerceFlow:", error);
  //       return { error: error.message };
  //     }
  //   };

  const bigcommerceFlow = async () => {
    
   
      // console.log(cartId + "cart/add.js======================+> clicked")
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: `{"lineItems":[{"quantity":${qtyCount + 1},"productId":${
          ele?.productId
        },"variantId":${selectedVarient}}]}`,
      };
      window.parent.postMessage({ type: "bigComFlow", options }, "*");
      // console.log("localStorage", localStorage.getItem("cartId"));
    //   const response = await fetch(
    //     localStorage.getItem("cartId")
    //       ? `/api/storefront/carts/${localStorage.getItem(
    //           "cartId"
    //         )}/items?include=lineItems.physicalItems.options`
    //       : "/api/storefront/carts?include=lineItems.physicalItems.options",
    //     options
    //   )
    //     .then((response) => response.json())
    //     .catch((err) => console.error(err));

    //   if (response) {
    //     console.log("response", response);
    //     let tempList = [];
    //     let productArray = [];
    //     response.lineItems?.physicalItems?.forEach((element) => {
    //       tempList.push(element?.productId);
    //       productArray.push({
    //         productId: element?.productId,
    //         quantity: element?.quantity,
    //         varient: [{ varientId: element?.variantId }],
    //       });
    //     });
    //     let totalPrice = response?.cartAmount;
    //     let subTotal = response?.baseAmount?.toString();
        
    //     let cart = await getBigcommerceCart();
    //     addCreateCartUlai(
    //       response?.id,
    //       ele?.userId,
    //       productArray,
    //       totalPrice,
    //       subTotal
    //     );
    //     setIsExist(cart.includes(parseInt(ele.productId)) ? true : false);
    //     setShowButtonLoader(false);
    //   }
    // } catch (error) {
    //   console.error("Error in bigcommerceFlow:", error);
    // }
  };
  const handleSubmit = async () => {
 
    setShowButtonLoader(true);
    if (botDetails?.storeName === "Shopify") {
      await shopifyFlow();
    } else if (botDetails?.storeName === "Bigcommerce") {
      await bigcommerceFlow();
    }
  };
  useEffect(() => {}, [qtyCount]);
  useEffect(() => {}, [outOfStock]);
  useEffect(() => {
    setOutOfStock(ele?.varient[0]?.isOutOfStock);
    if (!outOfStock && ele.varient) {
      selectVarient(ele.varient[0]?.varientId);
    }
    sendKafkaEvent({
      eventName: "websdk_product_display",
      productDetails: {
        id: selectedVarient,
        quantity: qtyCount + 1,
        productImage: ele.images[0],
        productName: ele.productName,
      },
      userId: botDetails.userId,
      chatId: getSessionId(localStorage.getItem("sessionUUID")),
    });
  }, []);
  useEffect(() => {
    setIsExist(cartList?.includes(parseInt(ele?.productId)) ? true : false);
  }, [cartList]);
  const isColorDark = (color) => {
    const colorObj = tinycolor(color);
    return colorObj.isDark();
  };
  return (
    <ul className="list-message">
      <li className="message">
        <div className="product-image">
          <img src={ele.images[0]} alt="" />
        </div>
        <div className="product-details">
          <p
            className="product-name"
            style={{
              paddingLeft: 4,
              lineHeight: 1.2,
              maxHeight: "3.6em",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 3,
              height: "55px",
              textOverflow: "ellipsis",
              color:"black"
            }}
          >
            {ele.productName}
          </p>
          {/* <p className="product-description">
          Product Description:
          {ele.productSpecification}
        </p> */}
          <select
            style={{ position: "relative", top: 8 }}
            className="varient-list"
            onChange={(e) => {
              selectVarient(e.target.value);
            }}
          >
            {ele.varient &&
              ele.varient.map((e) => {
                return (
                  <option key={e.varientId} value={e.varientId}>
                    <p className="varient-list-name" style={{color:"black"}}>{e.varientName} </p>
                    Price: Rs.{" "}{e.varientPrice}
                  </option>
                );
              })}
          </select>
          {/* Button Container */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              width: "80%",
              //  height:"40px",
              display: "flex",
              justifyContent: " center",
            }}
          >
            <Button
              style={{
                background: botDetails.accentColor,
                opacity: outOfStock ? 0.5 : 1,
                pointerEvents: outOfStock ? "none" : "auto",
                height:"30px",
                border:`1px solid ${botDetails.accentColor}`,
                color:isColorDark(botDetails?.accentColor) ? "white" : "black",
                fontSize:"15px"
              }}
              size="md"
           
          
           
            
              _hover={{
                border: `1px solid ${botDetails.accentColor}`,
                bg: `white`,
                color: isColorDark(botDetails?.accentColor)
                  ? botDetails?.accentColor
                  : "black",
              }}
              
              boxShadow="md"
              isLoading={showButtonLoader}
              className="ulai-add-to-cart-button"
              disabled={outOfStock && showButtonLoader}
              onClick={() => {
                if (!isExist) {
                  handleSubmit();
                  sendKafkaEvent({
                    eventName: "websdk_add_to_cart",
                    productsDetail: {
                      id: selectedVarient,
                      quantity: qtyCount + 1,
                    },
                    userId: botDetails?.userId,
                    chatId: getSessionId(localStorage.getItem("sessionUUID")),
                  });
                } else {
                  window.parent.postMessage({ type: "checkoutHref",cartPath }, "*");
                  sendKafkaEvent({
                    eventName: "websdk_view_cart",
                    userId: botDetails?.userId,
                    chatId: getSessionId(localStorage.getItem("sessionUUID")),
                  });
                  // href = cartPath;
                }
              }}
            >
              {outOfStock ? (
                "Out of stock"
              ) : showButtonLoader ? (
                <Spinner
                  color={
                    isColorDark(botDetails?.accentColor) ? "white" : "black"
                  }
                />
              ) : isExist ? (
                "View Cart"
              ) : (
                "Add to cart"
              )}
            </Button>
          </div>
        </div>
      </li>
    </ul>
  );
};